import SurveyHttp from '../../http';


export const UseCaseFormatter = {
  formatHttpRequest({ surveyForm, orderId }) {
    const formattedAnswers = surveyForm.questions.reduce((answers, question) => {
      const { id, answer } = question;

      if (Array.isArray(answer)) {
        answers.push(...answer.map(answerValue => ({ answer: answerValue, questionId: id })));
      }
      else {
        answers.push({ answer, questionId: id });
      }

      return answers;
    }, []);

    const formattedPayload = {
      formId: surveyForm.id,
      answers: formattedAnswers,
      orderId
    };

    return formattedPayload;
  }
};

const SubmitSurvey = {
  async execute(payload) {
    try {
      const { formId, ...rest } = UseCaseFormatter.formatHttpRequest(payload);

      const requestBody = { ...rest };

      await SurveyHttp.postSurvey(formId, requestBody);
    }
    catch (error) {
      throw error;
    }
  }
};

export default SubmitSurvey;
